module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/5-f74506bfc99befe83b3199775a87011f.jpg";